import { render } from "./Fees_Payment.vue?vue&type=template&id=87061b8c&scoped=true"
import script from "./Fees_Payment.vue?vue&type=script&lang=js"
export * from "./Fees_Payment.vue?vue&type=script&lang=js"

import "./Fees_Payment.vue?vue&type=style&index=0&id=87061b8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87061b8c"]])

export default __exports__